import { ReactComponent as LocationIcon } from 'assets/image/svg/location-outline.svg';
import { ReactComponent as CityIcon } from 'assets/image/svg/city-view.svg';
import { ReactComponent as NeighborhoodIcon } from 'assets/image/svg/neighborhood.svg';
import { ReactComponent as MapIcon } from 'assets/image/svg/map.svg';
import { ReactComponent as GlobeIcon } from 'assets/image/svg/globe.svg';
import { ReactComponent as AirportIcon } from 'assets/image/svg/airport-transfer.svg';
import { ReactComponent as LandmarkIcon } from 'assets/image/svg/landmark.svg';
import { ReactComponent as MuseumIcon } from 'assets/image/svg/museum.svg';
import { ReactComponent as MonumentIcon } from 'assets/image/svg/monument.svg';
import { ReactComponent as TouristAttractionIcon } from 'assets/image/svg/tourist-attraction.svg';
import { ReactComponent as StadiumIcon } from 'assets/image/svg/stadium.svg';
import { ReactComponent as BeachIcon } from 'assets/image/svg/beach.svg';
import { ReactComponent as ThemeParkIcon } from 'assets/image/svg/theme-park.svg';
import { ReactComponent as SchoolIcon } from 'assets/image/svg/school.svg';
import { ReactComponent as NationalParkIcon } from 'assets/image/svg/national-park.svg';
import { ReactComponent as HistoricSiteIcon } from 'assets/image/svg/historic-site.svg';
import { ReactComponent as ScenicLookoutIcon } from 'assets/image/svg/scenic-lookout.svg';
import { ReactComponent as ZooIcon } from 'assets/image/svg/zoo.svg';
import { ReactComponent as AquariumIcon } from 'assets/image/svg/aquarium.svg';

import { ReactComponent as HotelIcon } from 'assets/image/svg/hotel.svg';

const poiCategoryIcons: Record<string, any> = {
   hotel: HotelIcon,
   motel: HotelIcon,
   hostel: HotelIcon,
   lodging: HotelIcon,
   resort: HotelIcon,
   bed_and_breakfast: HotelIcon,
   vacation_rental: HotelIcon,
   airport: AirportIcon,
   landmark: LandmarkIcon,
   museum: MuseumIcon,
   monument: MonumentIcon,
   tourist_attraction: TouristAttractionIcon,
   stadium: StadiumIcon,
   beach: BeachIcon,
   theme_park: ThemeParkIcon,
   university: SchoolIcon,
   national_park: NationalParkIcon,
   historic_site: HistoricSiteIcon,
   scenic_lookout: ScenicLookoutIcon,
   zoo: ZooIcon,
   aquarium: AquariumIcon,
};

const featureTypeIcons: Record<string, any> = {
   country: GlobeIcon,
   region: MapIcon,
   district: MapIcon,
   place: CityIcon,
   locality: CityIcon,
   neighborhood: NeighborhoodIcon,
};

export const getLocationIcon = (suggestion: { poi_category_ids?: string[]; feature_type?: string }): any => {
   const categories = suggestion?.poi_category_ids;
   if (categories?.length) {
      for (const category of categories) {
         if (poiCategoryIcons[category]) return poiCategoryIcons[category];
      }
      for (const key of Object.keys(poiCategoryIcons)) {
         if (categories.some((cat: string) => cat.includes(key) || key.includes(cat))) {
            return poiCategoryIcons[key];
         }
      }
   }

   const featureType = suggestion?.feature_type?.toLowerCase();
   if (featureType && featureTypeIcons[featureType]) return featureTypeIcons[featureType];

   return LocationIcon;
};
